import { render } from "./HomeArticles.vue?vue&type=template&id=4ec33fd0"
import script from "./HomeArticles.vue?vue&type=script&lang=ts"
export * from "./HomeArticles.vue?vue&type=script&lang=ts"

import "./HomeArticles.vue?vue&type=style&index=0&id=4ec33fd0&lang=scss"
script.render = render

export default script